module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.type == 'header') ? [_c('h3', [_vm._v(_vm._s(_vm.getLabel()))])] : [_c('label', [_vm._v(_vm._s(_vm.getLabel()))]), _vm._v(" "), _c('p', [_c('FormatField', {
    attrs: {
      "value": _vm.fieldValue,
      "type": _vm.type
    }
  })], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33f2f844!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderLabelAndValue.vue
// module id = 909
// module chunks = 2